import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export type Context = 'apprentice' | 'tutor' | 'manager' | 'alumni';

export const CONTEXT_LABELS: { [key in Context]: string } = {
  apprentice: 'Stagiaire',
  tutor: 'Tuteur',
  manager: 'Coordonnateur',
  alumni: 'Alumni',
};

/** Un AUTRE contexte disponible que l'actif, avec son nombre de notifications en attente — alimente l'indicateur croisé. */
export type CrossContextIndicator = {
  context: Context;
  label: string;
  notificationsCount: number;
};

/**
 * Sélecteur de contexte (Sprint 3) — quel rôle l'identité a choisi de tenir
 * pour la session en cours, quand elle en a plusieurs de disponibles
 * (`AuthorizationService.getAvailableContexts`). Volontairement en mémoire
 * seulement, jamais persisté (décision actée : l'écran de choix réapparaît
 * à chaque nouvelle session, pas de mémorisation sur l'appareil) — un
 * rechargement complet de page compte comme une nouvelle session.
 */
@Injectable({
  providedIn: 'root',
})
export class ContextService {
  private selectedContextSubject: BehaviorSubject<Context | null> = new BehaviorSubject<Context | null>(null);
  selectedContext$: Observable<Context | null> = this.selectedContextSubject.asObservable();

  setContext(context: Context): void {
    this.selectedContextSubject.next(context);
  }

  getContext(): Context | null {
    return this.selectedContextSubject.getValue();
  }

  /** Appelé à la déconnexion : la prochaine session redemande le contexte. */
  clear(): void {
    this.selectedContextSubject.next(null);
  }
}
